/* eslint-disable no-console */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getLanguageType } from 'constants/Language'

import { fetchFastsportToken } from 'actions/games/creators'
import { beginSignIn } from 'actions/creators/Auth'
import { isStage } from 'shared/domainUtils.js'

const GAME_ID = isStage ? 2661 : 14085

class LuckyChiken extends Component {
  onClick = () => {
    const { gamblerId, isActiveSlide } = this.props
    if (isActiveSlide) {
      if (gamblerId) {
        this.launchGame()
      } else {
        this.props.beginSignIn()
      }
    }
  }

  launchGame = async () => {
    const { gamblerId, languageId } = this.props

    try {
      const language = getLanguageType(languageId).name
      const queryParam = `?gamblerId=${gamblerId}&language=${language}`

      const response = await fetch(`/api/games/${GAME_ID}/launch/${queryParam}`)

      if (!response.ok) {
        throw new Error('Network response was not ok')
      }

      const data = await response.json()

      window.location.assign(data.LaunchUrl)
    } catch (error) {
      console.error('Failed to fetch game details:', error)
    }
  }

  render() {
    const { name } = getLanguageType(this.props.languageId)
    const btnSrc = `/img/banners/lucky-chiken/btn-${name}.png`
    const textSrc = `/img/banners/lucky-chiken/text-${name}.png`

    return (
      <div onClick={this.onClick} className="lucky-chiken-banner">
        <img src={'/img/banners/lucky-chiken/mid.png'} className="mid" alt="" />
        <img src={'/img/banners/lucky-chiken/logo.png'} className="logo" alt="" />
        <img src={btnSrc} className="btn" alt="" />
        <img src={textSrc} className="text" alt="" />
      </div>
    )
  }
}

export default connect(
  state => {
    const user = state.auth.get('user')
    return {
      gamblerId: user && user.get('gamblerId'),
      languageId: state.application.get('languageId'),
    }
  },
  { fetchFastsportToken, beginSignIn }
)(LuckyChiken)



// WEBPACK FOOTER //
// ./js/sport-betting/components/main-page/banners/lucky-chiken/index.jsx